export const APPOINTMENTS_LOADED = 'APPOINTMENTS_LOADED';
export const APPOINTMENTS_SORTED = 'APPOINTMENTS_SORTED';
export const APPOINTMENTS_USER_PREFERENCE_LOADED = 'APPOINTMENTS_USER_PREFERENCE_LOADED';
export const APPOINTMENTS_FILTERED = 'APPOINTMENTS_FILTERED';
export const APPOINTMENTS_PATIENT_NOTIFY_PREFERENCE_LOADED = 'APPOINTMENTS_PATIENT_NOTIFY_PREFERENCE_LOADED';
export const APPOINTMENTS_TOGGLE_FILTER_PANEL = 'APPOINTMENTS_TOGGLE_FILTER_PANEL';
export const UPCOMING_APPOINTMENTS_LOADED = 'UPCOMING_APPOINTMENTS_LOADED';
export const UPCOMING_APPOINTMENTS_LOAD_FAILED = 'UPCOMING_APPOINTMENTS_LOAD_FAILED';
